import Section from '../ui/Section';
import SectionTitle from '../ui/SectionTitle';
import { Stagger, StaggerItem } from '../ui/Reveal';
import { industries } from '../../data/industries';

const IndustriesSection = () => {
  return (
    <Section id="industries" className="bg-surface-alt">
      <SectionTitle
        eyebrow="Who We Serve"
        title="Industries We Wish To Serve"
        subtitle="Delivering specialized solutions across diverse industry verticals"
      />

      <Stagger className="grid gap-6 sm:grid-cols-2 lg:grid-cols-3" stagger={0.07}>
        {industries.map((industry) => {
          const Icon = industry.icon;
          return (
            <StaggerItem key={industry.id} className="h-full">
              <div className="group gradient-ring relative flex h-full flex-col rounded-2xl border border-line bg-card p-6 shadow-card transition-all duration-300 hover:-translate-y-1.5 hover:shadow-card-hover">
                <span className="flex h-12 w-12 items-center justify-center rounded-xl bg-gradient-to-br from-brand-500 to-accent-500 text-white shadow-lg shadow-brand-600/25">
                  <Icon className="h-6 w-6" aria-hidden="true" />
                </span>
                <h3 className="mt-5 text-lg font-bold text-content">{industry.name}</h3>
              </div>
            </StaggerItem>
          );
        })}
      </Stagger>
    </Section>
  );
};

export default IndustriesSection;
